import { render, staticRenderFns } from "./DepartmentsInput.vue?vue&type=template&id=c6e106bc"
import script from "./DepartmentsInput.vue?vue&type=script&lang=js"
export * from "./DepartmentsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports